import React from 'react';
import { IBericht } from '../../../../interfaces/berichten';
import { IColumn } from '@fluentui/react';
import './BerichtBezorgingenTable.scss';
import OhkTable from 'components/OhkTable';

interface IBerichtBezorgingTableProps {
    items: IBericht[];
    loading: boolean;
    onSelectionChanged?: (ids: string[]) => void;
    columns: IColumn[];
}


const BerichtBezorgingenTable: React.FC<IBerichtBezorgingTableProps> = ({
                                                                            items,
                                                                            loading,
                                                                            onSelectionChanged,
                                                                            columns
                                                                        }) => {

    const handleGetKey = (item): string => {
        return (item as IBericht).key ?? "";
    };

    return (
        <div className="berichtbezorgingen-table">
            <OhkTable
                disableSort={false}
                columns={columns}
                items={items}
                loading={loading}
                onGetKey={handleGetKey}
                onSelectionChanged={onSelectionChanged}
            />
        </div>
    );
};

export default BerichtBezorgingenTable;